export default __webpack_public_path__ + "static/media/26-burns.c62eff7e.png";